import React, { useState, useEffect } from "react";

import { Row, Col, Card, CardBody, Button } from "reactstrap";

// components
import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from "@fullcalendar/interaction";
import listPlugin from '@fullcalendar/list';
import moment from "moment";

// helpers
import { formateDateandTimeApi } from "helpers/formats";

// services
import { showMessage } from "services/message.js";
import { api_GET } from "services/api_service.js";
import ConfirmacaoVistoria from "./ConfirmacaoVistoria";

export default function CalendarioVistoria({handleReturn}) {

    const [showLoading, setshowLoading] = useState(false);
    const [eventosCalendario, set_eventosCalendario] = useState([]);

    const loadEventosCalendario = () => {
        setshowLoading(true);
        api_GET(`AgendamentoVistoria/GetFromCalendario`).then(result => {
            setshowLoading(false);
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                let _eventos = [];
                result.data.map(m => {
                    _eventos.push({
                        requerimentoTransportadorAgendamento_Id: m.requerimentoTransportadorAgendamento_Id,
                        placa: m.placa,
                        id: m.requerimentoTransportadorAgendamento_Id,
                        start: formateDateandTimeApi(m.dataHora),
                        title: m.placa,
                        backgroundColor: "#6bd098",
                        allDay: false
                    })
                })
                set_eventosCalendario(_eventos);
            }
        });
    }

    useEffect(() => {
        loadEventosCalendario();
    }, []);

    const [evento, set_evento] = useState(null);
    const handleEventClick = (e) => {
        set_evento(eventosCalendario.filter(f => f.requerimentoTransportadorAgendamento_Id == e.event.id)[0]);
    }

    const handleReturnConfirmacaoVistoria = (reload) => {
        set_evento(null);
        if (reload)
            loadEventosCalendario();
    }

    return (
        <>
            {showLoading &&
                <div className="carregandoCmp">
                    <div className="box">
                        <img src={require("assets/img/loading.gif")}></img>
                    </div>
                </div>
            }
            <div className="content">
                <Row>
                    <Col md="12">
                        <Button type="button" color="Primary" onClick={handleReturn}><i className="fas fa-chevron-left"></i>  Voltar</Button>
                        <Card className="border-success mb-2 ">
                            <CardBody>
                                <Row>
                                    <Col md="12">
                                        <FullCalendar
                                            plugins={[dayGridPlugin, interactionPlugin, listPlugin]}
                                            initialView="dayGridMonth"
                                            locale="pt-br"
                                            selectable="true"
                                            headerToolbar={{
                                                left: 'title',
                                                center: '',
                                                right: 'prev,next'
                                            }}
                                            eventClick={handleEventClick}
                                            events={eventosCalendario}
                                        />
                                    </Col>
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>
            {evento != null &&
                <ConfirmacaoVistoria 
                    requerimentoTransportadorAgendamento_Id={evento.requerimentoTransportadorAgendamento_Id}
                    placa={evento.placa}
                    handleReturn={handleReturnConfirmacaoVistoria}
                    setshowLoading={setshowLoading}
                >
                </ConfirmacaoVistoria>
            }
        </>
    );
};

